import Vue from 'vue'
import httpManager from '../../util/common'
import  * as d3 from 'd3'
import XEUtils from 'xe-utils'
let vm = {
  delimiters: ['{', '}'],
  props: {
    oaid: String,
  },
  data: () => {
    return {
      data: null,
      divloading: false
    }
  },
  methods: {
    toReportDownload() {
      this.$router.push(`/entity/${this.oaid}/esg/report/download`)
    },
    getESGData() {
      let oaid = this.oaid
      let self = this
      self.divloading = true
      if(!oaid){
        oaid='04b8ce51-a3e1-11ea-bc6e-54bf6471772d'
      }
      let params = new Map()
      params.set("oaid", oaid)
      httpManager("esg_entity_ratings_all", params)
        .then(response => {
          if(response.data.data){
            self.data = response.data.data
          }
          self.drawChart()
          self.divloading = false
        })
        .catch(error => {
          console.log(error)
          self.divloading = false
        })
    },

    drawChart: function () {
      let self = this
      let transGrade = function (gradeStr) {
        let rating = {
          'AAA': 9,
          'AA': 8,
          'A': 7,
          'BBB': 6,
          'BB': 5,
          'B': 4,
          'CCC': 3,
          'CC': 2,
          'C': 1
        }
        let gradeNum=['C','CC','CCC','B','BB','BBB','A','AA','AAA']
        if(typeof(gradeStr)=='string')
          return rating[gradeStr]
        else{
          return gradeNum[gradeStr-1]
        }

      }
      let virtual_data = []
      var now_date = new Date()
      let month_interval = 3
      /*
        虚拟数据，当self.data为空时使用
        数据最少为10个，以填充图表的横坐标
        month_interval为虚拟数据的时间间隔
      */
      for(let i=0; i< 10;i++) {
        let time = now_date.setMonth(now_date.getMonth() - month_interval)
        let temp={'year': time, 'rating': 0}
        virtual_data.unshift(temp)
      }
      let final_data = self.data?self.data:virtual_data

      let temp = final_data.map(x => ({'year':x.year,
      'rating':transGrade(x.rating)}))
      let data = Object.assign(temp, {y: "$ Close"})//Object.assign(self.data.map(({date, close}) => ({date, value: close})), {y: "$ Close"})
      d3.select("#esg_rating_line_chart").select('*').remove()
      let height = 170
      let width = 416
      let svg = d3.select("#esg_rating_line_chart").append("svg").attr("viewBox", [0, 0, width, height])
      let margin = ({top: 40, right: 17, bottom: 47, left: 52})
      let point_count = data.length
      let x = d3.scaleLinear().domain([data[0]['year'], data[data.length-1]['year']]).nice()
        .range([margin.left, width - margin.right])
      let y = d3.scaleLinear().domain([1,9])
        .range([height - margin.bottom, margin.top])
      let xAxis = g => g
        .attr("transform", `translate(0,${height - margin.bottom +13})`)
        .call(d3.axisBottom(x).ticks(point_count>10?10:point_count).tickFormat(d=>XEUtils.toDateString(d-10*24*60*60*1000, 'yyyyMM')) )
      .call(g => g.selectAll(".tick text").attr('transform','translate(-19,8)rotate(-30)'))
      let yAxis = g => g
        .attr("transform", `translate(${margin.left},0)`)
        .call(d3.axisLeft(y).tickFormat(d => transGrade(d)))
        .call(g => g.select(".domain").remove())
        .call(g => g.select(".tick:last-of-type text").clone()
          .attr("x", 3)
          .attr("text-anchor", "start")
          .attr("font-weight", "bold")
          .text(""))

      let line = d3.line()
        .x(d => x(d.year))
        .y(d => y(d.rating))
        // .interpolate("cardinal")
      svg.append("g").call(xAxis)
      svg.append("g").call(yAxis)
      svg.append("path")
        .datum(data)
        .attr("fill", "none")
        .attr("stroke", "#c92525")
        .attr("stroke-width", 2)
        .attr("stroke-linejoin", "round")
        .attr("stroke-linecap", "round")
        .attr("d", line)

      svg.node()
    }

  },
  mounted(){
        this.getESGData()
    },
}
Vue.component("esg-rating-line-chart", vm)
export default vm



// WEBPACK FOOTER //
// ./src/esg/js/esg_rating_line_chart.js